import { Box, Grid, Typography } from "@mui/material";
import "../styles/css/contact.css";

const Contact = () => {
  return (
    <div>
      <Box
        display="flex"
        sx={{
          p: { xs: "30px", sm: "20px 150px" },
          display: "flex",
          marginTop: "15vh",
          justifyContent: { xs: "center", sm: "start" },
          alignItems: "center",
        }}
      >
        <Box display="flex" flexDirection="column">
          <Typography
            variant="p"
            sx={{
              fontWeight: "800",
              color: "#363435",
              fontSize: { xs: "3rem", sm: "4.5rem", md: "6rem" },
              fontFamily: "Switzer-Variable",
            }}
          >
            Contact Us
          </Typography>

          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            sx={{
              paddingTop: "2rem",
            }}
          >
            <Typography
              variant="p"
              sx={{
                color: "#363435",
                fontWeight: "300",
                fontSize: { xs: "1.2rem", sm: "1.4rem", md: "1.8rem" },
              }}
            >
              For projects and collaboration
            </Typography>

            <Box
              id="contact-details-container"
              display="flex"
              gap={9}
              sx={{ flexDirection: { xs: "column", sm: "column", md: "row" } }}
            >
              <Box display="flex" flexDirection="column" gap={1}>
                <Typography
                  variant="p"
                  sx={{
                    color: "#363435",
                    fontSize: "1rem",
                  }}
                >
                  Email us at
                </Typography>

                <Box
                  sx={{
                    width: { xs: "280px", sm: "200px", md: "200px" },
                    backgroundColor: "#2F5325",
                    borderRadius: "8px",
                    p: 1,
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{
                      color: "white",
                      fontSize: "1rem",
                    }}
                  >
                    info@insightbrandcom.com
                  </Typography>
                </Box>
              </Box>

              <Box display="flex" flexDirection="column" gap={1}>
                <Typography
                  variant="p"
                  sx={{
                    color: "#363435",
                    fontSize: "1rem",
                  }}
                >
                  Call us at
                </Typography>

                <Box
                  sx={{
                    width: { xs: "280px", sm: "200px", md: "200px" },
                    backgroundColor: "#2F5325",
                    borderRadius: "8px",
                    p: 1,
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{
                      color: "white",
                      fontSize: "1rem",
                    }}
                  >
                    +91 361 2522 444
                  </Typography>
                </Box>
              </Box>

              <Box display="flex" flexDirection="column" gap={1}>
                <Typography
                  variant="p"
                  sx={{
                    color: "#363435",
                    fontSize: "1rem",
                  }}
                >
                  Or, call us at
                </Typography>

                <Box
                  sx={{
                    width: { xs: "280px", sm: "200px", md: "200px" },
                    backgroundColor: "#2F5325",
                    borderRadius: "8px",
                    p: 1,
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{
                      color: "white",
                      fontSize: "1rem",
                    }}
                  >
                    +91 9706089025
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Grid
              container
              sx={{
                width: { xs: "100%", md: "500px" },
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Grid
                item
                md={12}
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  // alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="p"
                  sx={{
                    fontWeight: "bold",
                    // textAlign: "center",
                    // margin: "auto",
                    fontSize: "1rem",
                  }}
                >
                  Headquarters
                </Typography>
                <Typography
                  variant="p"
                  sx={{
                    fontWeight: "bold",
                    // textAlign: "center",
                    // margin: "auto",
                    marginTop: "20px",
                    fontSize: "1rem",
                  }}
                >
                  Insight Brandcom Private Limited
                </Typography>
                <Typography
                  variant="p"
                  sx={{
                    // textAlign: "center",
                    // margin: "auto",
                    fontSize: "1rem",
                  }}
                >
                  4A, Royale Arcade, B.Baruah Road,
                  <br />
                  Ulubari, Guwahati- 781007, Assam
                </Typography>
                <Typography
                  variant="p"
                  sx={{
                    fontWeight: "bold",
                    // textAlign: "center",
                    marginTop: "20px",
                    fontSize: "1rem",
                  }}
                >
                  Branch Locations
                </Typography>
              </Grid>
            </Grid>

          

           
           

            
       <Box
  display="flex"
  sx={{
    flexWrap: "wrap",
    gap: 3,
    marginTop: "20px",
    maxWidth: "600px",
  }}
>
  {[
    "Shillong",
    "Ranchi",
    "Bhubaneshwar",
    "Delhi",
    "Jaipur",
    "Mumbai",
    "Kanpur",
    "Lucknow",
    "Bhopal",
    "Jalandhar",
    "Chennai",
    "Kolkata",
  ].map((city) => (
    <Box
      key={city}
      sx={{
        padding: "10px 16px",
        border: "1px solid #E0E0E0",
        borderRadius: "8px",
        fontSize: "0.95rem",
        fontWeight: "500",
        color: "#363435",
      }}
    >
      {city}
    </Box>
  ))}
</Box>

          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Contact;